/**
 *
 * ParrotSoftware
 * SettingsServiceAreasProvider constants
 *
 */
export const GET_SERVICES_AREAS = 'providers/settings/ServiceAreas/GET_SERVICES_AREAS';
export const VALIDATE_NAME_AREA = 'providers/settings/ServiceAreas/VALIDATE_NAME_AREA';
export const CREATE_SERVICE_AREA = 'providers/settings/ServiceAreas/CREATE_SERVICE_AREA';
export const DELETE_SERVICE_AREA = 'providers/settings/ServiceAreas/DELETE_SERVICE_AREA';
export const UPDATE_SERVICE_AREA = 'providers/settings/ServiceAreas/UPDATE_SERVICE_AREA';
export const SERVICE_AREA_CHANGE_DEFAULT = 'providers/settings/ServiceAreas/SERVICE_AREA_CHANGE_DEFAULT';
export const GET_SERVICE_AREA_DETAILS = 'providers/settings/ServiceAreas/GET_SERVICE_AREA_DETAILS';
export const UPDATE_AREA_POSITION = 'providers/settings/ServiceAreas/UPDATE_AREA_POSITION';
